// import React, { useState } from "react";
// import Select from "react-select";
// import Form from "react-bootstrap/Form";
// import PhoneInput from "react-phone-input-2";
// import { useNavigate } from "react-router-dom";

// import Account_Created_Modal from "../account-created-modal/Account_Created_Modal";
// import Common_Login_Button from "../../../common_components/common-login-button/Common_Login_Button";
// import Login_Modal from "../../../common_components/common-login-button/login_modal/Login_Modal";

// import "react-phone-input-2/lib/style.css";
// import "./Customer_Login.css";

// const Customer_Login = ({ activeTab }) => {
//   const [mobile, setMobile] = useState("");
//   const [isRegistering, setIsRegistering] = useState(false);
//   const [showAccountModal, setShowAccountModal] = useState(false);
//   const [showLoginModal, setShowLoginModal] = useState(false);
//   const [otp, setOtp] = useState(["", "", "", ""]);
//   const [fullName, setFullName] = useState("");
//   const [adhar, setAdhar] = useState("");
//   const [loginOtp, setLoginOtp] = useState("");
//   const [modalText, setModalText] = useState("");

//   const navigate = useNavigate();

//   const selectStyles = {
//     control: (base) => ({
//       ...base,
//       height: "45px",
//       borderRadius: "30px",
//       border: "1px solid #ddd",
//       boxShadow: "none",
//       "&:hover": { border: "1px solid #aaa" },
//     }),
//     indicatorSeparator: () => ({ display: "none" }),
//     valueContainer: (base) => ({ ...base, padding: "0 20px" }),
//   };

//   const cityOptions = [
//     { value: "mumbai", label: "Mumbai" },
//     { value: "pune", label: "Pune" },
//   ];
//   const stateOptions = [{ value: "maharashtra", label: "Maharashtra" }];

//   const handleOtpChange = (value, index) => {
//     if (isNaN(value)) return;
//     const newOtp = [...otp];
//     newOtp[index] = value.substring(value.length - 1);
//     setOtp(newOtp);
//     if (value && index < 3) {
//       document.getElementById(`otp-${index + 1}`)?.focus();
//     }
//   };

//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     if (isRegistering) {
//       setModalText("Account Created Successfully!");
//       setShowAccountModal(true);

//       setTimeout(() => {
//         setShowAccountModal(false);
//         setIsRegistering(false);
//         setFullName("");
//         setAdhar("");
//         setOtp(["", "", "", ""]);
//       }, 3000);
//     } else {
//       setModalText("Login Successfully!");
//       setShowAccountModal(true);

//       setTimeout(() => {
//         setShowAccountModal(false);
//         navigate("/");
//       }, 3000);
//     }
//   };

//   return (
//     <div className="customer-card-container">
//       <Form className="customer-form-body" onSubmit={handleFormSubmit}>
//         <div className="customer-header-row">
//           <div className="customer-title-stack">
//             <span className="customer-main-title">
//               {isRegistering ? "Register as" : "Login as"} {activeTab}
//             </span>
//             <p className="customer-subtitle">to Oll Type Services</p>
//           </div>
//           <img
//             src="./assets/header/Oll-Type-Services.png"
//             alt="Logo"
//             className="customer-brand-logo"
//           />
//         </div>

//         {!isRegistering ? (
//           <div className="login-fields-container">
//             <div className="customer-input-group">
//               <PhoneInput country={"in"} value={mobile} onChange={setMobile} />
//               <label className="static-label">Mobile No*</label>
//             </div>
//             <div className="customer-input-group">
//               <Form.Control
//                 type="text"
//                 placeholder=" "
//                 required
//                 value={loginOtp}
//                 onChange={(e) => setLoginOtp(e.target.value)}
//               />
//               <label>Enter OTP</label>
//             </div>
//           </div>
//         ) : (
//           <div className="scroll-form-body">
//             <div className="register-fields-container">
//               <div className="register-fields-wrapper">
//                 <div className="customer-input-group">
//                   <Form.Control
//                     type="text"
//                     placeholder=" "
//                     required
//                     value={fullName}
//                     onChange={(e) => setFullName(e.target.value)}
//                   />
//                   <label>Full Name*</label>
//                 </div>
//                 <div className="customer-input-group">
//                   <PhoneInput
//                     country={"in"}
//                     value={mobile}
//                     onChange={setMobile}
//                   />
//                   <label className="static-label">Mobile No*</label>
//                 </div>
//                 <div className="customer-otp-dotted-box">
//                   <label className="customer-otp-label">Enter OTP</label>
//                   <div className="customer-otp-slots">
//                     {otp.map((digit, index) => (
//                       <div key={index} className="customer-otp-slot">
//                         <input
//                           id={`otp-${index}`}
//                           type="text"
//                           maxLength="1"
//                           value={digit}
//                           placeholder="●"
//                           className="customer-otp-input"
//                           onChange={(e) =>
//                             handleOtpChange(e.target.value, index)
//                           }
//                         />
//                         <hr className="customer-otp-line" />
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//                 <div className="customer-input-group">
//                   <Form.Control
//                     type="text"
//                     placeholder=" "
//                     required
//                     value={adhar}
//                     onChange={(e) => setAdhar(e.target.value)}
//                   />
//                   <label>Adhar No*</label>
//                 </div>
//                 <div className="customer-input-group">
//                   <Select
//                     options={cityOptions}
//                     styles={selectStyles}
//                     placeholder=""
//                     classNamePrefix="react-select"
//                   />
//                   <label className="floating-label">City*</label>
//                 </div>
//                 <div className="customer-input-group">
//                   <Select
//                     options={stateOptions}
//                     styles={selectStyles}
//                     placeholder=""
//                     classNamePrefix="react-select"
//                   />
//                   <label className="floating-label">State*</label>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         <div className="customer-footer-actions">
//           {!isRegistering ? (
//             <div className="footer-content-block">
//               <Common_Login_Button text="Login" />
//               <div className="customer-toggle-footer">
//                 <span className="acc-text">Don't have an account?</span>
//                 <button
//                   type="button"
//                   className="customer-toggle-link"
//                   onClick={() => setIsRegistering(true)}
//                 >
//                   Create Account
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <div className="footer-content-block">
//               <Common_Login_Button text="Register" />
//               <div className="customer-toggle-footer">
//                 <span className="acc-text">You have an account?</span>
//                 <button
//                   type="button"
//                   className="customer-toggle-link"
//                   onClick={() => {
//                     setIsRegistering(false);
//                     setOtp(["", "", "", ""]);
//                   }}
//                 >
//                   Login Now
//                 </button>
//               </div>
//             </div>
//           )}
//         </div>
//       </Form>

//       <Account_Created_Modal
//         showAccountModal={showAccountModal}
//         handleAccountModalClose={() => setShowAccountModal(false)}
//         text={modalText}
//       />

//       <Login_Modal
//         showLoginModal={showLoginModal}
//         handleLoginModalClose={() => setShowLoginModal(false)}
//       />
//     </div>
//   );
// };

// export default Customer_Login;
import React, { useState } from "react";
import Select from "react-select";
import Form from "react-bootstrap/Form";
import PhoneInput from "react-phone-input-2";
import { useNavigate } from "react-router-dom";

import Account_Created_Modal from "../account-created-modal/Account_Created_Modal";
import Common_Login_Button from "../../../common_components/common-login-button/Common_Login_Button";
import Login_Modal from "../../../common_components/common-login-button/login_modal/Login_Modal";

import "react-phone-input-2/lib/style.css";
import "./Customer_Login.css";

const Customer_Login = ({ activeTab }) => {
  const [mobile, setMobile] = useState("");
  const [isRegistering, setIsRegistering] = useState(false);
  const [showAccountModal, setShowAccountModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [fullName, setFullName] = useState("");
  const [adhar, setAdhar] = useState("");
  const [loginOtp, setLoginOtp] = useState("");
  const [modalText, setModalText] = useState("");

  const navigate = useNavigate();

  const selectStyles = {
    control: (base) => ({
      ...base,
      height: "45px",
      borderRadius: "30px",
      border: "1px solid #ddd",
      boxShadow: "none",
      "&:hover": { border: "1px solid #aaa" },
    }),
    indicatorSeparator: () => ({ display: "none" }),
    valueContainer: (base) => ({ ...base, padding: "0 20px" }),
  };

  const cityOptions = [
    { value: "mumbai", label: "Mumbai" },
    { value: "pune", label: "Pune" },
  ];
  const stateOptions = [{ value: "maharashtra", label: "Maharashtra" }];

  const handleOtpChange = (value, index) => {
    if (isNaN(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);
    if (value && index < 3) {
      document.getElementById(`otp-${index + 1}`)?.focus();
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    if (isRegistering) {
      setModalText("Account Created Successfully!");
      setShowAccountModal(true);
      setTimeout(() => {
        setShowAccountModal(false);
        setIsRegistering(false);
        setFullName("");
        setAdhar("");
        setOtp(["", "", "", ""]);
      }, 3000);
    } else {
      setModalText("Login Successfully!");
      setShowAccountModal(true);
      setTimeout(() => {
        setShowAccountModal(false);
        navigate("/");
      }, 3000);
    }
  };

  return (
    <div className="customer-card-container">
      <Form className="customer-form-body" onSubmit={handleFormSubmit}>
        <div className="customer-header-row">
          <div className="customer-title-stack">
            <span className="customer-main-title">
              {isRegistering ? "Register as" : "Login as"} {activeTab}
            </span>
            <p className="customer-subtitle">to Oll Type Services</p>
          </div>
          <img
            src="./assets/header/Oll-Type-Services.png"
            alt="Logo"
            className="customer-brand-logo"
          />
        </div>

        {!isRegistering ? (
          <div className="login-fields-container">
            <div className="customer-input-group">
              <PhoneInput country={"in"} value={mobile} onChange={setMobile} />
              <label className="static-label">Mobile No*</label>
            </div>
            <div className="customer-input-group">
              <Form.Control
                type="text"
                placeholder=" "
                required
                value={loginOtp}
                onChange={(e) => setLoginOtp(e.target.value)}
              />
              <label>Enter OTP</label>
            </div>
          </div>
        ) : (
          <div className="scroll-form-body">
            <div className="register-fields-container">
              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  required
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                />
                <label>Full Name*</label>
              </div>
              <div className="customer-input-group">
                <PhoneInput
                  country={"in"}
                  value={mobile}
                  onChange={setMobile}
                />
                <label className="static-label">Mobile No*</label>
              </div>
              <div className="customer-otp-dotted-box">
                <label className="customer-otp-label">Enter OTP</label>
                <div className="customer-otp-slots">
                  {otp.map((digit, index) => (
                    <div key={index} className="customer-otp-slot">
                      <input
                        id={`otp-${index}`}
                        type="text"
                        maxLength="1"
                        value={digit}
                        placeholder="●"
                        className="customer-otp-input"
                        onChange={(e) => handleOtpChange(e.target.value, index)}
                      />
                      <hr className="customer-otp-line" />
                    </div>
                  ))}
                </div>
              </div>
              <div className="customer-input-group">
                <Form.Control
                  type="text"
                  placeholder=" "
                  required
                  value={adhar}
                  onChange={(e) => setAdhar(e.target.value)}
                />
                <label>Adhar No*</label>
              </div>
              <div className="customer-input-group">
                <Select
                  options={cityOptions}
                  styles={selectStyles}
                  placeholder=""
                  classNamePrefix="react-select"
                />
                <label className="floating-label">City*</label>
              </div>
              <div className="customer-input-group">
                <Select
                  options={stateOptions}
                  styles={selectStyles}
                  placeholder=""
                  classNamePrefix="react-select"
                />
                <label className="floating-label">State*</label>
              </div>
            </div>
          </div>
        )}

        <div className="customer-footer-actions">
          <div className="footer-content-block">
            <Common_Login_Button text={isRegistering ? "Register" : "Login"} />
            <div className="customer-toggle-footer">
              <span className="acc-text">
                {isRegistering
                  ? "You have an account?"
                  : "Don't have an account?"}
              </span>
              <button
                type="button"
                className="customer-toggle-link"
                onClick={() => {
                  setIsRegistering(!isRegistering);
                  setOtp(["", "", "", ""]);
                }}
              >
                {isRegistering ? "Login Now" : "Create Account"}
              </button>
            </div>
          </div>
        </div>
      </Form>

      <Account_Created_Modal
        showAccountModal={showAccountModal}
        handleAccountModalClose={() => setShowAccountModal(false)}
        text={modalText}
      />
      <Login_Modal
        showLoginModal={showLoginModal}
        handleLoginModalClose={() => setShowLoginModal(false)}
      />
    </div>
  );
};

export default Customer_Login;
